import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.s6o_1 = code;
        this.t6o_1 = partyId;
        this.u6o_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.s6o_1 + ', partyId=' + this.t6o_1.toString() + ', guildId=' + this.u6o_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.s6o_1);
        result = imul(result, 31) + this.t6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.u6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.s6o_1 === other.s6o_1))
          return false;
        if (!this.t6o_1.equals(other.t6o_1))
          return false;
        if (!(this.u6o_1 === other.u6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
